// src/services/coupons/couponsApi.js
import axiosInstance from "../server/axios";

// services/coupons/couponsApi.js

export const getCoupons = async (queryParams = '') => {
  try {
    const response = await axiosInstance.get(`/admin/coupons${queryParams ? `?${queryParams}` : ''}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createCoupon = async (couponData) => {
  const token = localStorage.getItem('authToken');
  const response = await axiosInstance.post("/admin/coupons/create", couponData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  });
  return response.data;
};

export const updateCoupon = async (id, couponData) => {
  const token = localStorage.getItem('authToken');
  const response = await axiosInstance.put(`/admin/coupons/${id}/update`, couponData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  });
  return response.data;
};

export const deleteCoupon = async (id) => {
  const token = localStorage.getItem('authToken');
  const response = await axiosInstance.delete(`/admin/coupons/${id}/delete`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  });
  return response.data;
};

export const toggleCouponStatus = async (id) => {
  const token = localStorage.getItem('authToken');
  const response = await axiosInstance.post(`/admin/coupons/${id}/toggle-status`, {}, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  });
  return response.data;
};

export const checkCouponValidity = async (data) => {
  const token = localStorage.getItem('authToken');
  const response = await axiosInstance.post("/admin/coupons/check-validity", data, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  });
  return response.data;
};

// === NOUVELLES MÉTHODES POUR LA GESTION DES UTILISATEURS ===

/**
 * Récupérer tous les utilisateurs disponibles
 */
export const getUsers = async () => {
  const token = localStorage.getItem('authToken');
  const response = await axiosInstance.get("/admin/coupons/users/available", {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  });
  return response.data;
};

/**
 * Récupérer les utilisateurs d'un coupon spécifique
 */
export const getCouponUsers = async (couponId) => {
  const token = localStorage.getItem('authToken');
  const response = await axiosInstance.get(`/admin/coupons/${couponId}/users`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  });
  return response.data;
};

/**
 * Attacher des utilisateurs à un coupon
 */
export const attachUsersToCoupon = async (couponId, userIds) => {
  const token = localStorage.getItem('authToken');
  const response = await axiosInstance.post(`/admin/coupons/${couponId}/users/attach`, {
    user_ids: userIds
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  });
  return response.data;
};

/**
 * Détacher des utilisateurs d'un coupon
 */
export const detachUsersFromCoupon = async (couponId, userIds) => {
  const token = localStorage.getItem('authToken');
  const response = await axiosInstance.delete(`/admin/coupons/${couponId}/users/detach`, {
    data: {
      user_ids: userIds
    },
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  });
  return response.data;
};

/**
 * Synchroniser (remplacer) tous les utilisateurs d'un coupon
 */
export const syncCouponUsers = async (couponId, userIds) => {
  const token = localStorage.getItem('authToken');
  const response = await axiosInstance.put(`/admin/coupons/${couponId}/users/sync`, {
    user_ids: userIds
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  });
  return response.data;
};

/**
 * Obtenir les détails d'un coupon spécifique
 */
export const getCoupon = async (couponId) => {
  const token = localStorage.getItem('authToken');
  const response = await axiosInstance.get(`/admin/coupons/${couponId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  });
  return response.data;
};

export const checkCoupon = async (couponCode, amount) => {
  try {
    const token = localStorage.getItem('authToken');
    const user = JSON.parse(localStorage.getItem('user'));
    const response = await axiosInstance.post("/check-coupon", {
      copon: couponCode,
      amount: amount,
      user_id:user.id
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAvailableCoupons = async () => {
  try {
    const token = localStorage.getItem('authToken');
    const response = await axiosInstance.get("/available", {  }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};




